import { Alert, AlertTitle, Button, ListItem, UnorderedList } from '@chakra-ui/react';
import { useInvestorAccountModel } from '@common/models/InvestorAccountModel';
import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/apps/invest/config';

export const Eligibility: React.FC = () => {
  const investorModel = useInvestorAccountModel();
  return (
    <Alert
      status="info"
      alignItems={'flex-start'}
      justifyContent="center"
      flexDirection={'column'}
      gap="10px"
      marginBottom={'10px'}
      variant="left-accent">
      <AlertTitle>
        We still need the following information from you before you can invest in our Cash Flow fund. Follow the wizard
        on the Dashboard to complete your profile.
      </AlertTitle>
      <UnorderedList style={{ listStyle: 'inside', marginBottom: 10 }}>
        {investorModel.cashflowEligibility?.needsBankAccount && <ListItem>Bank Account</ListItem>}
        {investorModel.cashflowEligibility?.needsToFillOutAnnualIncome && <ListItem>Annual Income</ListItem>}
        {investorModel.cashflowEligibility?.needsToFillOutNetWorth && <ListItem>Net Worth</ListItem>}
        {investorModel.cashflowEligibility?.needsToFillOutExperienceSurvey && (
          <ListItem>Experience Information</ListItem>
        )}
        {investorModel.cashflowEligibility?.needsToFillOutObjectivesSurvey && (
          <ListItem>Objectives Information</ListItem>
        )}
      </UnorderedList>
      <Button
        as={Link}
        to={ROUTES.dashboard}
        variant="outline"
        colorScheme={'blue'}
        size={'lg'}
        borderColor="blue.300"
        color="blue.300"
        width="100%">
        Dashboard
      </Button>
    </Alert>
  );
};
